(function () {
  var STORAGE_KEY = 'tm_wishlist';

  function readWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function writeWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {
      /* storage unavailable, ignore */
    }
  }

  function productIdFor(button) {
    var card = button.closest('card-product');
    return card ? card.id : null;
  }

  function syncButton(button) {
    var id = productIdFor(button);
    if (!id) return;
    var active = readWishlist().indexOf(id) !== -1;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  }

  function toggle(button) {
    var id = productIdFor(button);
    if (!id) return;
    var list = readWishlist();
    var index = list.indexOf(id);
    if (index === -1) {
      list.push(id);
    } else {
      list.splice(index, 1);
    }
    writeWishlist(list);
    syncButton(button);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-wishlist-toggle]');
    if (!button) return;
    event.preventDefault();
    toggle(button);
  });

  function initAll() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(syncButton);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
